import * as React from "react";
import { DateSelect } from "../../atoms/forms/DateSelect";
import { ICommonInputsControlsWithLabel } from "../../atoms/forms/ICommonInputsControls";
import { useTranslation } from 'react-i18next';

// All the incoming values
interface IProps {
}

// Outgoing functions
interface IDispatch {
}

// Actual Component
export type AllProps = IProps & IDispatch & ICommonInputsControlsWithLabel<Date>;

export const ContractDateSelect = (props: AllProps) => {
    const { t: tContactpoint } = useTranslation('contactpoint');
    
    return (
        <DateSelect
            {...props}
        />
    );
}
